import React, { Component } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from '../';
import PropTypes from 'prop-types';

export const FooterDiv = styled.div`
  background-color: #36363e;
  padding-top: 20px;
  color: #bbb;
  text-decoration: none;
  .footer__logo {
    width: 100px;
    margin-top: -0.625rem;
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      margin-top: -0.625rem;
      display: inline-block;
      margin-bottom: 0;
      vertical-align: middle;
      text-align: center;
    }
  }
  .footer__tagline {
    margin-top: 15px;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      margin-left: 1.25rem;
      padding-left: 1.25rem;
      border-left: 1px solid #777;
    }
  }
  .footer__main {
    font-size: 13px;
    position: relative;
    min-height: 1px;
    padding-left: 0px;
    float: left;
    width: 100%;
    a {
      color: #bbb;
      text-decoration: none;
      &:hover {
        color: #bbb;
        opacity: 0.8;
        text-decoration: none;
      }
    }
  }
  .footer__links,
  .footer__partners {
    padding: 0;
    margin: 0;
    line-height: 18px;
  }
  .footer__app-links {
    min-height: 1px;
    padding-right: 0px;
    width: 100%;
    margin-bottom: 20px;
  }
  hr {
    border-top-style: initial;
    border-right-style: initial;
    border-left-style: initial;
    border-top-color: initial;
    border-right-color: initial;
    border-left-color: initial;
    opacity: 0.3;
    border-width: 0px 0px 1px;
    border-image: initial;
    border-bottom: 1px solid rgb(119, 119, 119);
    margin: 1.25rem 0px;
  }
`;
const ColLogo = Col.extend`
  margin-top: 10px;
  text-align: center;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    text-align: left;
  }
`;
const ColLink = Col.extend`
  text-align: center;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    text-align: left;
  }
`;
const ColApp = Col.extend`
  text-align: center;
  margin-top: 10px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    text-align: right;
    margin-top: 0px;
  }
`;
export class FooterSimple extends Component {
  static propTypes = {
    siteSource: PropTypes.string
  };

  render() {
    const { siteSource } = this.props;
    return (
      <FooterDiv>
        <Container>
          <Row>
            <ColLogo xs={0} md={12}>
              <a
                href="/"
                rel="noopener noreferrer"
                data-ga-category={siteSource}
                data-ga-action={`${siteSource} - Clicked Home`}
                data-ga-label={`${siteSource} - Clicked Home`}
              >
                <img
                  src="https://assets.homeimprovementpages.com.au/images/hipages-primary-logo-reversed.svg"
                  className="footer__logo"
                />
              </a>
              <span className="footer__tagline">Australia&apos;s #1 site to hire tradespeople</span>
              <hr />
            </ColLogo>
          </Row>
          <Row>
            <ColLogo xs={12} md={0}>
              <a
                href="/"
                rel="noopener noreferrer"
                data-ga-category={siteSource}
                data-ga-action={`${siteSource} - Clicked Home`}
                data-ga-label={`${siteSource} - Clicked Home`}
              >
                <img
                  src="https://assets.homeimprovementpages.com.au/images/hipages-primary-logo-reversed.svg"
                  className="footer__logo"
                />
              </a>
            </ColLogo>
            <ColLogo xs={12} md={0}>
              <span className="footer__tagline">Australia&apos;s #1 site to hire tradespeople</span>
              <hr />
            </ColLogo>
          </Row>
          <Row>
            <ColLink xs={12} md={7.5}>
              <div className="footer__main">
                <p className="footer__links">
                  hipages ©{' '}
                  <a
                    href="/content/all_licensing"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Licensing`}
                    data-ga-label={`${siteSource} - Clicked`}
                  >
                    Licensing{' '}
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/content/council"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Council Regulations`}
                    data-ga-label={`${siteSource} - Clicked`}
                  >
                    Council Regulations
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/trust"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Trust and Quality`}
                    data-ga-label={`${siteSource} - Clicked`}
                  >
                    Trust &amp; Quality
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/terms"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Terms &amp; Conditions`}
                    data-ga-label={`${siteSource} - Clicked`}
                  >
                    Terms
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/privacy"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Privacy Policy`}
                    data-ga-label={`${siteSource} - Clicked`}
                  >
                    Privacy
                  </a>
                </p>
                <p className="footer__partners">
                  Partner sites:{' '}
                  <a
                    href="http://www.naturaltherapypages.com.au"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Partner Sites - NTP`}
                    data-ga-label={`${siteSource} - Clicked`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Natural Therapy Pages
                  </a>{' '}
                  ·{' '}
                  <a
                    href="http://www.petpages.com.au"
                    data-ga-category={siteSource}
                    data-ga-action={`${siteSource} - Clicked Partner Sites - PET`}
                    data-ga-label={`${siteSource} - Clicked`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pet Pages
                  </a>
                </p>
              </div>
            </ColLink>
            <ColApp xs={12} md={4.5}>
              <div className="footer__app-links">
                <a
                  href="https://app.appsflyer.com/id369786244?pid=hipages&amp;c=footer_desktop"
                  title="Download the hipages app on the App Store"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-ga-category={siteSource}
                  data-ga-action={`${siteSource} - Clicked Apple App Store`}
                  data-ga-label={`${siteSource} - Clicked`}
                >
                  <img
                    src="https://assets.homeimprovementpages.com.au/images/logo-app-store-v3.png"
                    className=""
                    width="130"
                    height="40"
                  />
                </a>
                <a
                  href="https://app.appsflyer.com/com.hip.consumer.android?pid=hipages&amp;c=footer_desktop"
                  title="Download the hipages business app on Google Play"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-ga-category={siteSource}
                  data-ga-action={`${siteSource} - Clicked Google Play Store`}
                  data-ga-label={`${siteSource} - Clicked`}
                >
                  <img
                    src="https://assets.homeimprovementpages.com.au/images/logo-google-play-v3.png"
                    className=""
                    width="135"
                    height="40"
                    style={{ marginLeft: 5 }}
                  />
                </a>
              </div>
            </ColApp>
          </Row>
        </Container>
      </FooterDiv>
    );
  }
}
